module.exports = __webpack_public_path__ + "img/aliyun-abs.9fd3de13.jpg";